import { definePanel } from '@/app/definePanel';
import { CameraIcon } from '@/components/occurra/icons/CameraIcon';
import { LayoutsIcon } from '@/components/occurra/icons/LayoutsIcon';
import { CamerasTab } from '@/types/camerasList';

export default definePanel({
    id: 'cameras_list',
    title: 'Cameras',
    description: 'Every camera and the saved layouts. Watch one camera or a whole site.',
    icon: CameraIcon,
    launcherTabs: [
        {
            key: CamerasTab.Cameras,
            label: 'Cameras',
            description: 'Every camera of the organization. Watch one camera or a whole site.',
            icon: CameraIcon,
            props: { camerasTab: CamerasTab.Cameras },
        },
        {
            key: CamerasTab.Layouts,
            label: 'Layouts',
            description: 'The saved layouts. Open one to watch its cameras together.',
            icon: LayoutsIcon,
            props: { camerasTab: CamerasTab.Layouts },
        },
    ],
    width: { min: 240, default: 240, max: 400, fill: false },
    modes: ['view', 'settings'],
    themes: 'any',
    // The panel draws its header itself: the Cameras and Layouts tabs.
    isHeaderless: true,
    // Leftmost of the list panels — it is the navigator every camera workflow
    // starts from.
    order: 3,
    // Mutual exclusions live in src/app/exclusions.ts. The tree's compatible
    // neighbours are the two camera surfaces it navigates to (camera_view,
    // camera_settings): opening any other list — events, objects, motion, video
    // search, or a settings list — closes it, and vice versa. It is a
    // navigator, not a sidebar that tags along everywhere.
    // Opening the list brings the mode's camera surface along in the same
    // commit (rightmost/no-displacement gated — see resolveAutoChild); its
    // camera_view ↔ camera_settings auto-open pairing still applies.
    autoChild: { view: 'camera_view', settings: 'camera_settings' },
    // Share cameraId and layoutId with camera_view so the list highlights
    // whichever camera or layout is currently open (and survives reload via URL).
    urlSyncedProps: ['cameraId', 'layoutId'],
});
